import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enFaqTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "title": "Crystalogram",
          "info": "Information about the event",
          "sphere": "Sphere",
          "type": "Type",
          "examples": "Examples",
          "home": "Home",
          "faq": "FAQ",
          "current": "Current",
          "reference": "Reference",
          "discuss": "Discuss",
          "en": "EN",
          "ru": "RU",
          "referenceContent": "This is the reference section.",
          "faqContent": "Here are some frequently asked questions.",
          "discussContent": "<a href='https://t.me/+CJvdLD9F8JliMzVi' target='_blank'>Join the discussion</a>",
          "crystalogram": "Crystalogram",
          "powerControlSphere": "Power, Control, Force",
          "externalForces": "External Forces",
          "naturalPhenomena": "Natural phenomena, fire, water, earth, air",
          ...enFaqTranslations,
        }
      },
      ru: {
        translation: {
          "title": "Кристалограмма",
          "info": "Информация о событии",
          "sphere": "Сфера",
          "type": "Тип",
          "examples": "Примеры",
          "home": "Главная",
          "faq": "FAQ",
          "current": "Текущее",
          "reference": "Справочник",
          "discuss": "Обсудить",
          "en": "АНГ",
          "ru": "РУС",
          "referenceContent": "Это раздел справочника.",
          "faqContent": "Здесь представлены часто задаваемые вопросы.",
          "discussContent": "<a href='https://t.me/+CJvdLD9F8JliMzVi' target='_blank'>Присоединяйтесь к обсуждению </a>",
          "crystalogram": "Кристалограмма",
          "powerControlSphere": "Сила, Власть, Контроль",
          "externalForces": "Внешние силы",
          "naturalPhenomena": "Природные явления, огонь, вода, земля, воздух",
          ...ruTranslations,
        }
      }
    },
    lng: "ru",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;